import Swiper from 'swiper'

export function gsk(){
  var navItems = document.querySelectorAll('.site-gks .navigation li')
  function isPc() {
    return window.innerWidth >= 1024
  }
  navItems.forEach(function (item) {
    var childUl = item.querySelector(':scope > ul')
    if (!childUl) return
    var link = item.querySelector(':scope > a')
    if (!link) return
    link.addEventListener('click', function (e) {
      if (isPc()) return
        item.classList.toggle('is-open')
        e.preventDefault()
    })
  })

  // tab
  const tabAreas = document.querySelectorAll('.archive__tabs')

  tabAreas.forEach((tabs) => {
    const buttons = tabs.querySelectorAll('.archive__tabs__tab a')
    const panels = tabs.querySelectorAll('.archive__tabs__items > div')

    const closeAll = () => {
      buttons.forEach((button) => {
        button.classList.remove('is-active')
      })

      panels.forEach((panel) => {
        panel.style.display = 'none'
      })
    }

    const openPanel = (panelId) => {
      const targetButton = tabs.querySelector(
        `.archive__tabs__tab a[data-panel="${panelId}"]`
      )

      const targetPanel = tabs.querySelector(
        `.archive__tabs__items > div[data-panel="${panelId}"]`
      )

      if (!targetButton || !targetPanel) return

      targetButton.classList.add('is-active')
      targetPanel.style.display = 'block'
    }

    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault()

        const panelId = button.dataset.panel

        closeAll()
        openPanel(panelId)
      })
    })

    // 初期表示（最初のタブを開く）
    const firstButton = buttons[0]

    if (firstButton) {
      openPanel(firstButton.dataset.panel)
    }
  })


}